import React from 'react';
import Text from '../animation/Text';
import { RichTextModel } from '@/client';
import { ITextProps } from '../animation/Text';

interface IRichTextProps extends ITextProps {
  data: RichTextModel;
  className?: string;
  tag?: string;
  children?: React.ReactNode;
}

const RichText = ({ data, animate = false, animation, tag, children, ...props }: IRichTextProps) => {
  const { markup } = data || {};

  const content = markup ? { dangerouslySetInnerHTML: { __html: markup } } : { children };

  return <Text animate={animate || !!animation} animation={animation} tag={tag || 'div'} {...props} {...content} />;
};

RichText.displayName = 'RichText';

export default RichText;
